import { render, staticRenderFns } from "./RecordCreate.vue?vue&type=template&id=31bdf890&"
import script from "./RecordCreate.vue?vue&type=script&lang=js&"
export * from "./RecordCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports